











































































  import { Component, Vue, Watch } from 'vue-property-decorator'
import CartDetail from '@/components/panier/CartDetail.vue'
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import { AloPanier } from '@/models/alo/AloPanier'
import { AloCommande, getDefaultAloCommande } from '@/models/alo/AloCommande'
import AddressEdit from '@/components/administration/address/AddressEdit.vue'    
import { getDefaultAloAddress } from '@/models/alo/AloAddress'
import cloneDeep from 'clone-deep'
import { Stripe as StripeType, StripeCardElement } from '@stripe/stripe-js'
import router from '@/router'


@Component({
  name:"SessionHistory",
  props:{
    initialStep:{
      type:Number,
      default:1
    }
  },
  components:{CartDetail,AddressEdit}
})
export default class Profil extends Vue {
  initialStep!:number
  step = 1
  errorFacturation = "Adresse invalide"  
  address = getDefaultAloAddress()
  paying = false
  generatingIntent = false
  stripe!:StripeType
  card!:StripeCardElement
  cardError = 'Chargement formulaire carte'
  canPay = false
  commande = getDefaultAloCommande()
  

  get panier() {
    return this.$store.myGetters.panier
  }

  get postalCode(){
    return this.panier?.address?.adrPostalCode
  }

  @Watch("initialStep")
  onInitialStepChange(newStep:number) {
    this.step = newStep
  }

  @Watch("step")
  onStepChange(newStep:number) {
    this.step = newStep
    if(newStep == 1 && this.$route.name != 'Cart') this.$router.push({name:'Cart'})
    if(newStep == 2 && this.$route.name != 'Billing') this.$router.push({name:'Billing'})
    if(newStep == 3) {      
      if(this.validateAddress()){
        if(this.$route.name != 'Checkout') this.$router.push({name:'Checkout'})    
        this.tryGeneratePaiementIntent()
      }
      else{
        this.step = 2
      }      
    }
  }

  created(){    
    this.step = this.initialStep 
    //@ts-ignore   
         
    this.address = cloneDeep({...getDefaultAloAddress(),...this.panier.address})
  }

  mounted() {               
  }

  remplirAdresseAuto(){
    this.address = cloneDeep({...getDefaultAloAddress(),...this.$store.myGetters.user.address})
  }

  clearPanier()
  {
    this.$confirm(`Voulez vous vraiment vider votre panier ?`,{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          return this.$store.myActions.CLIENT_CLEAR_PANIER()
        } 
      })  
  }

  tryBuildStripeCard() {
    const elements = this.stripe.elements();
    if(!this.card) {
      this.card = elements.create("card",{            
        value:{
          postalCode:this.postalCode
        },
        hidePostalCode:true,
        style: {
          base: {
            color: "#32325d",
            fontFamily: 'Arial, sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
              color: "#32325d"
            }
          },
          invalid: {
            fontFamily: 'Arial, sans-serif',
            color: "#fa755a",
            iconColor: "#fa755a"
          }
        }     
      });

      this.card.mount("#card-element");
      this.card.on('ready', (event) => {
        this.cardError = '';
      });
      this.card.on('change', ({complete,error}) => {      
        if(complete) {
          this.canPay = true
          this.cardError = '';
        }
        else {          
          this.canPay = false
          if (error) {                    
            this.cardError = error.message;
          }
        }        
      });
    }
  }

  destroyed(){
    this.card.destroy()
  }

  udpateQty(payload:{fftId:number,qty:number}){        
    if(payload.qty == 0) {
      this.$confirm(this.$t('Cart.AlertRemoveItem').toString(),{title: this.$t('Global.ConfirmDelete'),buttonTrueText:this.$t('Global.Yes'),buttonFalseText:this.$t('Global.No')} as VuetifyConfirmObject).then( (response) => {
          if(response){
            this.$store.myActions.CLIENT_UPD_PANIER_ITEM_QTY(payload)
          }
        }
      )
    }
    else  {
      this.$store.myActions.CLIENT_UPD_PANIER_ITEM_QTY(payload)
    }
  }   

  isFacturationOk() {
    return !this.panier.address || (this.panier.address.ctyId > 0 && this.panier.address.adrPostalCode.length > 0)
  }

  validateAddress(){
    this.$store.myActions.CLIENT_SET_PANIER_ADDRESS(this.address)
    return (this.$refs.editAddress as AddressEdit).validate()
  }

  tryGeneratePaiementIntent() {    
    if(!this.$store.myGetters.isAuthenticated)  {                
      this.$store.myActions.AUTH_SET_REDIRECT_PATH(this.$route.path)
      this.$router.push({name:"Login"})
    }
    else{                         
      this.generatingIntent = true
      this.$store.myActions.CLIENT_CHECKOUT_REQUEST(this.panier).then((panier:AloPanier) => {
        
        //Tjs AE
        //this.stripe = Stripe('pk_live_51JT7rnBq8tY0RycQFpI7gHncZ7gqApM1M2W6dVf27tCuY9tnMSJyvX9EzYh95c5jkvO58WDnPmOxYt1ykSxwSi3d00owY5k1ek',{locale: 'fr'})       
        if(panier.items.some(i => i.psnId == 20)){          
          //AQUADOMIC AE
          //@ts-ignore
          //this.stripe = Stripe('pk_test_51JT7rnBq8tY0RycQWscZVTDZsea2WO6N7U3rTtZodyyLXg1nMiRGDcmZRJjqTrTbGU1GYjf46v6OLi9xunWCmPga00wsaiSlYq',{locale: 'fr'})                  
          this.stripe = Stripe('pk_live_51JT7rnBq8tY0RycQFpI7gHncZ7gqApM1M2W6dVf27tCuY9tnMSJyvX9EzYh95c5jkvO58WDnPmOxYt1ykSxwSi3d00owY5k1ek',{locale: 'fr'})       
        }
        else{
          //AQUADOMIC
          //@ts-ignore
          //this.stripe = Stripe('pk_test_51J1tgoLDYR0fjUjl77M9IvORAKls7W1OJQdPjWUNQiFnHqNJP0Cfb74xvTZ8pnrngwkFifkSOjYvu6BxDo2CuPOk00r2OS1kmN',{locale: 'fr'})        
          this.stripe = Stripe('pk_live_51J1tgoLDYR0fjUjlYRXMQhMSD1nLKJ6hBTSD3Meu8aPH7ri3KFNAPLOHBGiD4HgrKZWWySKThySEyye0q2rUUPkm00EWe5phrs',{locale: 'fr'})        
        }

        if(this.panier.prixTotal > 0)  this.tryBuildStripeCard()          
      })
      .catch((errorMessage)=>{
        console.log("errorMessage",errorMessage)
        this.$confirm(errorMessage ?? "Une erreur c'est produite merci de retenter",{title: "Problème de génération de votre commande",buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject).finally(()=>{
          this.step = 1
        })
      })
      .finally(()=>{
        this.generatingIntent = false
      })      
    }           
  }
 
  checkoutFree(){
    this.$store.myActions.CLIENT_CHECKOUT_FREE_REQUEST(this.panier)
    .then((panier:AloPanier) => {
       this.$confirm("Votre commande a bien été prise en compte vous allez recevoir une confirmation par email. Retrouvez vos achats dans votre compte",{title: "Commande validée",buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject).finally(()=>{
          this.$store.myActions.CLIENT_CLEAR_PANIER()
          this.$router.push({name:"ProfilAccount"})
        })    
    })
    .catch((errorMessage)=>{
        this.$confirm(errorMessage ?? "Une erreur est survenue lors de la validation merci de rééssayer ou nous contacter.",{title: "Erreur lors de la validation de la commande",buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)
    })
  }

  checkout(){    
    if(!this.canPay) {
      this.$confirm("Merci de remplir les information de votre carte bancaire avant de valider le paiement",{title: "Informations manquante",buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)      
    }
    else {      
      this.paying = true;
      //@ts-ignore
      this.stripe.confirmCardPayment(this.panier.clientSecret, {
        payment_method: {
          //@ts-ignore
          card: this.card/*,
          billing_details:{
            address:{          
              line1:this.panier.address.adrIndoorInfos??undefined,  
              line2:`${this.panier.address.adrNumberWay} ${this.panier.address.adrOutsideInfos}`,
              state:this.panier.address.adrPostBox??undefined,  
              postal_code:this.panier.address.adrPostalCode,            
              city:this.panier.address.libelle,
              country:"France",
            },
            name:this.$store.myGetters.user.libelle,
            email:this.$store.myGetters.user.usrEmail,
            phone:this.$store.myGetters.user.usrTel
          }*/
        }
      })
      .then((result) => {
        if (result.error) {
          // Show error to your customer
          this.$confirm(result.error.message!,{title: "Erreur lors du paiement",buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)
        } else {
          // The payment succeeded!
          this.$confirm("Votre paiement a bien été pris en compte vous allez recevoir une confirmation par email. Retrouvez vos achats dans votre compte",{title: "Paiement terminé",buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject).finally(()=>{
            this.$store.myActions.CLIENT_CLEAR_PANIER()
            this.$router.push({name:"ProfilAccount"})
          })      
        }
      }).finally(()=>{
        this.paying = false
      });    
    }
  }
}
